import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  FundOutlined,
  OrderedListOutlined,
  AuditOutlined,
  MessageOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { logOut, setEdit } from "../../redux/actions";
import admin from "../../const/api";
import history from "../../const/history";

const { SubMenu } = Menu;

const MenuList = (props) => {
  const { t } = useTranslation();
  // const {setEdit , edit} =  props
  const [openKeys, setOpenKeys] = useState([]);
  const [cats, setCats] = useState([]);
  const [length, setCatLength] = useState(null);
  const rootSubmenuKeys = ["10","50", "21", "31", "41", "51", "61"];

  const logOut = () => {
    localStorage.removeItem("access_token");
    props.logOut();
    history.push("/");
  };

  const getCategories = async () => {
    await admin.get("categories").then((res) => {
      setCatLength(res.data.content.length);
      setCats(
        res.data.content.map((p, index) => {
          if (p.locales === undefined) {
            logOut();
          }
          return {
            ...p,
            name: p.locales.find((l) => {
              return l.local === localStorage.getItem("locale");
            }).name,
          };
        })
      );
    });
  };

  useEffect(() => {
    getCategories();
  }, [t, localStorage.getItem("locale"), length]);

  useEffect(() => {
    let exp = localStorage.getItem("exp");
    let logtime = localStorage.getItem("now");
    let expDate = parseInt(logtime) + parseInt(exp);
    let time0ut = expDate - Date.now();
    if (time0ut <= 0) {
      logOut();
    }
  }, [Date.now()]);

  const onOpenChange = (openKeysList) => {
    const latestOpenKey = openKeysList.find(
      (key) => openKeys.indexOf(key) === -1
    );
    if (openKeysList[openKeysList.length - 1] === "21") {
      getCategories();
    }
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(openKeysList);
    } else {
      const opens = latestOpenKey ? [latestOpenKey] : [];
      setOpenKeys(opens);
    }
  };

  return (
    <Menu
      openKeys={openKeys}
      // inlineCollapsed={collapsed}
      mode="inline"
      theme="light"
      onOpenChange={onOpenChange}
      className="menu-ul"
    >

      <SubMenu
          key="50"
          title={
            <span>
             <HomeOutlined />
            <span>Şirkət</span>
          </span>
          }
      >
        <Menu.Item key="51">
          <Link to={`/about`}>
            <span>Haqqımızda</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="53">
          <Link to={`/mission`}>
            <span>Missiya və vizyon</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="54">
          <Link to={`/structure`}>
            <span>Fondun strukturu</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="52">
          <Link to={`/directories`}>
            <span>Rəhbərlik</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="55">
          <Link to={`/reports`}>
            <span>Hesabatlar</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="56">
          <Link to={`/partners`}>
            <span>Beynəlxalq əməkdaşlıq</span>
          </Link>
        </Menu.Item>

      </SubMenu>
      <SubMenu
          key="10"
          title={
            <span>
            <AuditOutlined />
            <span>{t("admin")}</span>
          </span>
          }
      >
        <Menu.Item key="14">
          <Link to={`/`}>
            <span>Məzənnə və statistika</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="12">
          <Link to={`/categories`}>
            <span>Kateqoriyalar</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="13">
          <Link to={`/instructions`}>
            <span>Video təlimatlar</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="11">
          <Link to={`/documents`}>
            <span>Qanunvericilik</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="18">
          <Link to={`/terms`}>
            <span>Şərtlər və qaydalar</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="19">
          <Link to={`/road-map`}>
            <span>Sahibkarlığın yol xəritəsi</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="19.1">
          <Link to={`/persons`}>
            <span>Vəzifəli şəxslər</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="16">
          <Link to={`/faq`}>
            <span>Faq</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="15">
          <Link to={`/languages`}>
            <span>Dillər</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="19.2">
          <Link to={`/translations`}>
            <span>Tərcümələr</span>
          </Link>
        </Menu.Item>
      </SubMenu>


      <SubMenu
          key="60"
          title={
            <span>
            <OrderedListOutlined />
            <span>Məhsullar</span>
          </span>
          }
      >
        <Menu.Item key="61">
          <Link to={`/product-list`}>
            <span>Məhsul siyahısı</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="62">
          <Link to={`/product-properties`}>
            <span>Məhsul xüsusiyyətləri</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="63">
          <Link to={`/product-documents`}>
            <span>Tələb olunan sənədlər</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="64">
          <Link to={`/product-priority`}>
            <span>Prioritet istiqamətlər</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="65">
          <Link to={`/product-chart`}>
            <span>Mexanizm şərhi</span>
          </Link>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="21"
        title={
          <span>
            <OrderedListOutlined />
            <span>Postlar</span>
          </span>
        }
      >
        {cats.map((c, i) => (
          <Menu.Item key={i}>
            <Link
              to={{
                pathname: `/posts/${c.id}`,
                state: { name: c.name },
              }}
            >
              <span>{c.name}</span>
            </Link>
          </Menu.Item>
        ))}
        {/*<Menu.Item key="23">*/}
        {/*  <Link to={`/products`}>*/}
        {/*    <span>Məhsullar</span>*/}
        {/*  </Link>*/}
        {/*</Menu.Item>*/}
        <Menu.Item key="24">
          <Link to={`/gallery`}>
            <span>Qalereya</span>
          </Link>
        </Menu.Item>
      </SubMenu>




      <SubMenu
        key="31"
        title={
          <span>
            <FundOutlined />
            <span>Xəritə</span>
          </span>
        }
      >
        <Menu.Item key="35">
          <Link to={`/projects`}>
            <span>Layihələr</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="32">
          <Link to={`/banks`}>
            <span>Banklar</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="33">
          <Link to={`/bank-branches`}>
            <span>Bank Filialları</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="34">
          <Link to={`/adminstrative`}>
            <span>İnzibati ərazilər</span>
          </Link>
        </Menu.Item>
      </SubMenu>
      <SubMenu
        key="41"
        title={
          <span>
            <MessageOutlined />
            <span>Əlaqə</span>
          </span>
        }
      >
        <Menu.Item key="42">
          <Link to={`/messages`}>
            <span>Mesajlar</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="44">
          <Link to={`/video-apply`}>
            <span>Video müraciətlər</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="43">
          <Link to={`/contact-info`}>
            <span>Əlaqə məlumatları</span>
          </Link>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
};

const mapStateToProps = ({ edit }) => {
  return { edit };
};

export default connect(mapStateToProps, { logOut, setEdit })(MenuList);
